export const categories = [
  {
    id: "latest-news",
    name: "最新动态",
    slug: "latest-news",
    description: "田中瞳最新新闻、活动报道与官方公告",
  },
  {
    id: "works",
    name: "作品集",
    slug: "works",
    description: "田中瞳代表作品全览，涵盖影视剧、综艺及写真作品",
  },
  {
    id: "interviews",
    name: "访谈专访",
    slug: "interviews",
    description: "深度访谈、幕后故事与独家专访内容",
  },
  {
    id: "career",
    name: "演艺经历",
    slug: "career",
    description: "田中瞳的演艺生涯回顾与发展历程",
  },
  {
    id: "gallery",
    name: "图集写真",
    slug: "gallery",
    description: "精选写真、活动照片与幕后花絮",
  },
  {
    id: "community",
    name: "粉丝社区",
    slug: "community",
    description: "粉丝互动、社区活动与专属内容",
  },
];

export const articles = [
  {
    id: "article-1",
    title: "田中瞳最新电视剧《星光之约》正式开机",
    slug: "new-drama-starlight-promise",
    category: "latest-news",
    categoryName: "最新动态",
    excerpt: "田中瞳确认出演2026年秋季档重磅电视剧《星光之约》，该剧由知名导演山田健一执导，预计将于10月在东京电视台首播。田中瞳将在剧中饰演一位坚强独立的年轻设计师。",
    contentHtml: `<p>近日，田中瞳正式确认将出演2026年秋季档重磅电视剧《星光之约》，这一消息引发了粉丝们的热烈讨论。</p><p>该剧由知名导演山田健一执导，编剧由曾创作过多部热门剧集的中村美咲担任。田中瞳将在剧中饰演一位名叫"星野明日香"的年轻时装设计师，她凭借自己的才华与坚持，在竞争激烈的时尚界闯出一片天地。</p><p>"能够参与这样一部充满正能量的作品，我感到非常荣幸，"田中瞳在开机发布会上表示，"星野明日香这个角色与我有着很多共鸣，她的坚韧和对梦想的执着深深打动了我。"</p><p>《星光之约》预计将于2026年10月在东京电视台首播，共12集。该剧还汇集了多位实力派演员，包括资深演员松本润和新人演员铃木花音。</p><p>粉丝们对这部作品充满期待，纷纷表示"已经迫不及待想看到田中瞳的新角色了"。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=A%20young%20Japanese%20actress%20at%20a%20drama%20press%20conference%2C%20elegant%20soft%20lighting%2C%20warm%20atmosphere%2C%20professional%20photography%2C%20clean%20cream%20background%2C%20sophisticated%20and%20graceful%20portrait%20style%2C%20minimal%20composition%2C%20editorial%20quality&width=800&height=450&seq=tanaka-article-01&orientation=landscape",
    publishDate: "2026-08-10",
    readTime: "5分钟",
    featured: true,
    tags: ["电视剧", "星光之约", "秋季档"],
  },
  {
    id: "article-2",
    title: "田中瞳荣获2026年度最佳女演员奖",
    slug: "best-actress-award-2026",
    category: "latest-news",
    categoryName: "最新动态",
    excerpt: "在第35届日本电视剧大赏中，田中瞳凭借在《午夜旋律》中的出色表现，荣获年度最佳女演员奖，这是她演艺生涯中的又一座重要里程碑。",
    contentHtml: `<p>在第35届日本电视剧大赏颁奖典礼上，田中瞳凭借在《午夜旋律》中的精湛演技，荣获年度最佳女演员奖，这一殊荣标志着她在演艺事业上迈上了新的台阶。</p><p>《午夜旋律》是一部以音乐为背景的都市情感剧，田中瞳在剧中饰演一位怀揣音乐梦想的酒吧驻唱歌手。她通过细腻的表演，将角色内心的挣扎与成长诠释得淋漓尽致，赢得了评委和观众的一致好评。</p><p>"这个奖项属于整个《午夜旋律》团队，"田中瞳在获奖感言中动情地说，"感谢导演的信任，感谢每一位工作人员的付出，也感谢一直支持我的粉丝们。我会继续努力，为大家带来更好的作品。"</p><p>这是田中瞳继两年前获得新人奖之后，首次斩获最佳女演员奖。业内人士普遍认为，这标志着田中瞳已经成长为日本演艺界的中坚力量。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=A%20Japanese%20actress%20holding%20an%20award%20trophy%20on%20stage%2C%20elegant%20gown%2C%20spotlight%2C%20warm%20golden%20tones%2C%20professional%20event%20photography%2C%20sophisticated%20ambiance%2C%20cream%20and%20gold%20background&width=800&height=450&seq=tanaka-article-02&orientation=landscape",
    publishDate: "2026-08-05",
    readTime: "4分钟",
    featured: true,
    tags: ["奖项", "最佳女演员", "午夜旋律"],
  },
  {
    id: "article-3",
    title: "《午夜旋律》幕后花絮独家揭秘",
    slug: "midnight-melody-behind-scenes",
    category: "interviews",
    categoryName: "访谈专访",
    excerpt: "田中瞳与我们分享了《午夜旋律》拍摄期间的趣事与感悟，从角色准备到与导演的默契合作，为你呈现一个真实的幕后故事。",
    contentHtml: `<p>随着《午夜旋律》的热播，我们特别邀请田中瞳进行了一次深入的幕后专访，聊聊这部剧拍摄期间那些不为人知的故事。</p><p>为了演好酒吧驻唱歌手"美咲"这一角色，田中瞳特意花了三个月时间学习吉他和声乐。"每天练习四到六个小时，手指都磨出了茧子，"田中瞳笑着回忆道，"但当我第一次在镜头前完整弹唱那首主题曲时，所有的辛苦都值得了。"</p><p>导演山田健一在采访中也对田中瞳赞赏有加："她的敬业精神令人敬佩。有一场雨中演唱的戏，她坚持不用替身，在零度的天气里拍了整整六个小时，最终呈现出的效果让整个剧组都为之动容。"</p><p>田中瞳还透露，剧中许多即兴表演的桥段都是她和搭档演员现场碰撞出的火花。"最好的表演往往不是写在剧本里的，"她说，"而是演员之间真实的情感交流。"</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=A%20Japanese%20actress%20in%20a%20cozy%20interview%20setting%2C%20warm%20ambient%20lighting%2C%20sitting%20on%20a%20comfortable%20sofa%2C%20soft%20cream%20and%20gold%20color%20palette%2C%20professional%20photography%2C%20natural%20and%20relaxed%20atmosphere&width=800&height=450&seq=tanaka-article-03&orientation=landscape",
    publishDate: "2026-07-28",
    readTime: "6分钟",
    featured: false,
    tags: ["幕后花絮", "访谈", "午夜旋律"],
  },
  {
    id: "article-4",
    title: "田中瞳×《VOGUE JAPAN》8月刊封面故事",
    slug: "vogue-japan-august-cover",
    category: "works",
    categoryName: "作品集",
    excerpt: "田中瞳登上《VOGUE JAPAN》8月刊封面，演绎夏日风尚。在专访中她谈及个人风格、职业规划以及对时尚的独特见解。",
    contentHtml: `<p>田中瞳登上了《VOGUE JAPAN》2026年8月刊的封面，这也是她首次为这本国际顶级时尚杂志拍摄封面。整组大片以"夏日流光"为主题，田中瞳以多套高级定制时装出镜，展现了与荧幕形象截然不同的时尚魅力。</p><p>在专访中，田中瞳分享了自己对时尚的理解："时尚是一种自我表达的方式。我不追随潮流，而是选择让自己感到舒适和自信的风格。"她还透露，私下里她更喜欢简约舒适的穿搭，"一件好的白衬衫搭配一条合身的牛仔裤，就是我最喜欢的日常造型。"</p><p>谈及未来的职业规划，田中瞳表示希望在演技上持续突破，同时也有兴趣尝试幕后工作。"我打算在未来几年学习编剧和导演，想要从不同的角度去理解影视创作。"</p><p>这期杂志自发行以来，销量节节攀升，不少读者表示田中瞳的封面造型"惊艳又高级"。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=A%20Japanese%20actress%20in%20a%20fashion%20magazine%20cover%20shoot%2C%20elegant%20summer%20fashion%2C%20warm%20lighting%2C%20professional%20editorial%20photography%2C%20sophisticated%20style%2C%20cream%20and%20soft%20gold%20background%2C%20high%20fashion%20aesthetic&width=800&height=450&seq=tanaka-article-04&orientation=landscape",
    publishDate: "2026-07-20",
    readTime: "5分钟",
    featured: true,
    tags: ["时尚", "VOGUE", "杂志封面"],
  },
  {
    id: "article-5",
    title: "从新人到实力派：田中瞳的十年演艺之路",
    slug: "ten-year-career-journey",
    category: "career",
    categoryName: "演艺经历",
    excerpt: "回顾田中瞳从2016年出道至今的十年演艺生涯，从青涩新人到如今的实力派演员，每一步都凝聚着她的努力与坚持。",
    contentHtml: `<p>2016年，年仅18岁的田中瞳通过电视剧《青春和弦》正式出道，虽然当时只是一个配角，但她清新自然的表演风格已经引起了业内的关注。</p><p>2018年，田中瞳迎来了事业的第一个转折点——在热播剧《东京之恋》中饰演女主角的妹妹，这个角色虽然戏份不多，却让她获得了当年的最佳新人奖提名。同年，她还出演了个人首部电影《夏日记忆》，开始在大银幕上崭露头角。</p><p>2020年至2022年是田中瞳事业的上升期。她先后主演了《午夜旋律》、《城市之光》等多部口碑与收视双丰收的作品，逐渐确立了实力派演员的地位。2023年，她凭借在电影《樱花树下》中的突破性表演，获得了日本电影学院奖最佳女主角提名。</p><p>2024年至今，田中瞳开始尝试更多元化的角色选择，从古装剧到现代都市剧，从文艺片到商业大片，不断拓宽自己的表演边界。她还涉足国际项目，参与了中日合拍电影《海上花》的拍摄。</p><p>十年光阴，田中瞳用一部部扎实的作品证明了自己的实力。正如她在一次采访中所说："演员这条路没有捷径，只有不断学习、不断突破，才能走得更远。"</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=A%20Japanese%20actress%20career%20retrospective%20collage%20style%2C%20elegant%20timeline%20aesthetic%2C%20warm%20vintage%20tones%2C%20professional%20portrait%20photography%2C%20soft%20cream%20background%2C%20sophisticated%20editorial%20quality&width=800&height=450&seq=tanaka-article-05&orientation=landscape",
    publishDate: "2026-07-15",
    readTime: "8分钟",
    featured: false,
    tags: ["演艺经历", "职业回顾", "成长历程"],
  },
  {
    id: "article-6",
    title: "田中瞳最新写真集《花语》正式发售",
    slug: "photobook-flower-language",
    category: "gallery",
    categoryName: "图集写真",
    excerpt: "田中瞳第二部个人写真集《花语》于近日正式发售，全书以四季花卉为主题，展现了田中瞳在不同季节中的多样魅力。",
    contentHtml: `<p>经过近一年的精心筹备，田中瞳的第二部个人写真集《花语》终于与粉丝们见面了。这部写真集由知名摄影师佐藤真一操刀，以"四季花卉"为主题，在日本各地取景拍摄。</p><p>整部写真集分为"春樱"、"夏莲"、"秋菊"、"冬梅"四个章节，每个章节都以对应的季节性花卉作为视觉元素。田中瞳在樱花树下、莲花池畔、菊花庭院和梅花雪景中，展现了四种截然不同的气质与风情。</p><p>"我想通过这部写真集，表达女性在不同季节、不同心境下的美，"田中瞳在发布会上表示，"每一种花都有自己绽放的方式，就像每一个阶段的自己都值得被记录。"</p><p>《花语》写真集一经发售便受到了粉丝们的热烈追捧，首周销量突破五万册。业内人士评价这是"一部兼具艺术性与观赏性的高品质写真作品"。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=A%20Japanese%20actress%20photobook%20launch%20event%2C%20elegant%20floral%20theme%2C%20warm%20soft%20lighting%2C%20sophisticated%20aesthetic%2C%20cream%20and%20soft%20pink%20background%2C%20professional%20event%20photography%2C%20minimal%20composition&width=800&height=450&seq=tanaka-article-06&orientation=landscape",
    publishDate: "2026-07-08",
    readTime: "4分钟",
    featured: false,
    tags: ["写真集", "花语", "四季"],
  },
  {
    id: "article-7",
    title: "田中瞳粉丝见面会东京站圆满落幕",
    slug: "fan-meeting-tokyo-2026",
    category: "community",
    categoryName: "粉丝社区",
    excerpt: "田中瞳2026年粉丝见面会东京站在东京国际论坛圆满举行，近三千名粉丝齐聚一堂，与偶像近距离互动。",
    contentHtml: `<p>7月5日，田中瞳2026年粉丝见面会"与你同行"东京站在东京国际论坛盛大举行。来自日本各地以及海外的近三千名粉丝齐聚一堂，度过了一个难忘的午后。</p><p>活动持续三个小时，内容丰富多彩。田中瞳不仅演唱了《午夜旋律》的主题曲，还与粉丝进行了多项互动游戏，包括即兴情景剧表演、猜歌名挑战以及粉丝问答环节。</p><p>"大家的热情真的让我非常感动，"田中瞳在活动尾声时眼含泪光地说，"正是因为有了你们的支持，我才能在演员这条路上坚持走到今天。我会继续努力，不辜负大家的期待。"</p><p>见面会还特别设置了慈善拍卖环节，田中瞳捐出了拍摄《午夜旋律》时使用的那把吉他进行拍卖，所得款项全部捐赠给了儿童艺术教育基金。</p><p>据悉，大阪站和名古屋站的见面会也将在近期举行，具体日期将于官方渠道公布。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=A%20Japanese%20actress%20at%20a%20fan%20meeting%20event%2C%20large%20venue%20with%20warm%20stage%20lighting%2C%20cheerful%20atmosphere%2C%20professional%20event%20photography%2C%20sophisticated%20aesthetic%2C%20cream%20and%20gold%20tones&width=800&height=450&seq=tanaka-article-07&orientation=landscape",
    publishDate: "2026-07-05",
    readTime: "5分钟",
    featured: true,
    tags: ["粉丝见面会", "东京", "互动"],
  },
  {
    id: "article-8",
    title: "田中瞳出任联合国儿童基金会亲善大使",
    slug: "unicef-ambassador-2026",
    category: "latest-news",
    categoryName: "最新动态",
    excerpt: "田中瞳正式被任命为联合国儿童基金会日本委员会亲善大使，将致力于推动儿童教育公益事业。",
    contentHtml: `<p>6月28日，联合国儿童基金会（UNICEF）日本委员会正式宣布，任命田中瞳为亲善大使。这是田中瞳首次担任国际组织的公益职务，标志着她在公益事业上迈出了重要一步。</p><p>田中瞳在任命仪式上表示："能够加入UNICEF大家庭，我感到无比荣幸。儿童是世界的未来，我将尽我所能，为改善儿童教育和生活条件贡献自己的力量。"</p><p>据悉，田中瞳将重点关注儿童艺术教育领域。她计划在未来一年内走访日本多个偏远地区，推动艺术教育资源的均衡分配。"艺术教育能够激发孩子们的创造力和想象力，"田中瞳说，"每个孩子都应该有机会接触和享受艺术的魅力。"</p><p>UNICEF日本委员会代表对田中瞳的加入表示热烈欢迎："田中瞳女士不仅是一位杰出的演员，更是一位充满爱心和社会责任感的人。我们相信她的影响力将为儿童公益事业带来积极的改变。"</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=A%20Japanese%20actress%20appointed%20as%20UNICEF%20ambassador%2C%20formal%20ceremony%2C%20elegant%20attire%2C%20warm%20professional%20lighting%2C%20sophisticated%20event%20photography%2C%20cream%20and%20soft%20blue%20background&width=800&height=450&seq=tanaka-article-08&orientation=landscape",
    publishDate: "2026-06-28",
    readTime: "4分钟",
    featured: false,
    tags: ["UNICEF", "公益", "亲善大使"],
  },
  {
    id: "article-9",
    title: "专访田中瞳：演员的自我修养与突破",
    slug: "exclusive-interview-self-cultivation",
    category: "interviews",
    categoryName: "访谈专访",
    excerpt: "在这篇深度专访中，田中瞳谈及了演技修炼、角色选择标准以及对未来演艺事业的规划与期待。",
    contentHtml: `<p>在一个温暖的午后，我们与田中瞳进行了一场深入的对谈。褪去荧幕上的光环，坐在对面的她显得格外真实而坦诚。</p><p><strong>Q：你如何为一个新角色做准备？</strong></p><p>"我会先通读剧本至少三遍，第一遍关注整体故事，第二遍聚焦我的角色，第三遍则是思考角色与其他人物的关系。然后我会写一份详细的角色小传，包括她的成长背景、性格特点、行为习惯等等。这个过程通常需要两到三周的时间。"</p><p><strong>Q：选择剧本时最看重什么？</strong></p><p>"故事的真诚度。一个好的故事未必需要有惊天动地的情节，但它必须能够打动人心。我特别看重角色是否有成长的空间，能否让观众产生共鸣。"</p><p><strong>Q：对未来有什么规划？</strong></p><p>"我希望能够挑战更多不同类型的角色，包括反派角色。同时也在考虑尝试舞台剧，那是完全不同的表演体验。长远来看，我希望能参与更多国际项目，把日本优秀的影视作品带给世界。"</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=A%20Japanese%20actress%20in%20a%20deep%20interview%2C%20thoughtful%20expression%2C%20warm%20natural%20light%20through%20window%2C%20cozy%20cafe%20setting%2C%20sophisticated%20photography%2C%20cream%20and%20warm%20brown%20tones%2C%20editorial%20quality&width=800&height=450&seq=tanaka-article-09&orientation=landscape",
    publishDate: "2026-06-20",
    readTime: "7分钟",
    featured: false,
    tags: ["深度访谈", "演技", "职业规划"],
  },
  {
    id: "article-10",
    title: "《城市之光》DVD&蓝光碟即将发行",
    slug: "city-light-dvd-bluray",
    category: "works",
    categoryName: "作品集",
    excerpt: "由田中瞳主演的热门电视剧《城市之光》确定将于8月中旬发行DVD和蓝光碟套装，内含大量未公开花絮。",
    contentHtml: `<p>去年冬季档热播剧《城市之光》的DVD和蓝光碟套装终于确定发行日期——2026年8月15日。这部由田中瞳主演的都市情感剧在播出期间获得了极高的收视率和口碑。</p><p>据悉，此次发行的套装将包含全12集正片，以及超过120分钟的特别收录内容。其中包括：从未公开的拍摄花絮、演员采访特辑、NG集锦，以及田中瞳与导演的评论音轨。</p><p>"评论音轨录制的过程非常有趣，"田中瞳分享道，"重新看自己的表演，和导演一起回忆拍摄时的点点滴滴，是一种很特别的体验。我们聊了很多剧本中没有写到的角色细节，希望粉丝们也能从中获得新的感受。"</p><p>套装还将附赠一本48页的豪华设定资料集，收录了剧中场景设计图、角色服装设定以及田中瞳亲自撰写的前言。</p><p>目前，各大电商平台已开放预订。预订特典为田中瞳亲笔签名的限量版明信片，数量有限，先到先得。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=A%20drama%20DVD%20box%20set%20product%20display%2C%20Japanese%20actress%20on%20cover%2C%20elegant%20presentation%2C%20warm%20studio%20lighting%2C%20sophisticated%20product%20photography%2C%20cream%20and%20soft%20gold%20background&width=800&height=450&seq=tanaka-article-10&orientation=landscape",
    publishDate: "2026-06-15",
    readTime: "4分钟",
    featured: false,
    tags: ["DVD", "蓝光", "城市之光"],
  },
  {
    id: "article-11",
    title: "盘点田中瞳五大经典角色",
    slug: "top-five-classic-roles",
    category: "works",
    categoryName: "作品集",
    excerpt: "从《青春和弦》中的青涩少女到《午夜旋律》里的成熟歌手，我们一起回顾田中瞳演艺生涯中五个令人难忘的经典角色。",
    contentHtml: `<p>田中瞳出道十年来，塑造了众多深入人心的角色。今天，我们为大家精心挑选了五个最具代表性的经典角色，一起重温那些动人的银幕瞬间。</p><p><strong>1. 铃木花音 - 《青春和弦》(2016)</strong><br/>田中瞳的出道作品。虽然只是配角，但她饰演的高中女生铃木花音纯真可爱，那股不加修饰的自然感让观众眼前一亮。</p><p><strong>2. 佐藤美咲 - 《午夜旋律》(2023)</strong><br/>这大概是田中瞳目前最具代表性的角色。一位怀揣音乐梦想的酒吧驻唱歌手，她将角色的脆弱与坚韧演绎得丝丝入扣，也是凭借这个角色获得了最佳女演员奖。</p><p><strong>3. 山田优子 - 《东京之恋》(2018)</strong><br/>娇俏可人的妹妹形象深入人心，田中瞳通过这个角色展现了她驾驭轻喜剧的能力。</p><p><strong>4. 高桥真理子 - 《樱花树下》(2023)</strong><br/>从少女到老年的跨越50年的表演，田中瞳在这部电影中展现了令人惊叹的演技层次感。</p><p><strong>5. 星野明日香 - 《星光之约》(2026)</strong><br/>虽然还未播出，但从预告片和剧照来看，田中瞳饰演的时尚设计师角色有望成为她的又一个经典。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=A%20collage%20of%20Japanese%20actress%20in%20five%20different%20drama%20roles%2C%20elegant%20montage%20style%2C%20warm%20cinematic%20tones%2C%20professional%20photography%2C%20sophisticated%20aesthetic%2C%20cream%20background&width=800&height=450&seq=tanaka-article-11&orientation=landscape",
    publishDate: "2026-06-10",
    readTime: "6分钟",
    featured: false,
    tags: ["经典角色", "回顾", "代表作"],
  },
  {
    id: "article-12",
    title: "田中瞳社交媒体粉丝突破800万",
    slug: "social-media-8-million",
    category: "community",
    categoryName: "粉丝社区",
    excerpt: "田中瞳官方Instagram账号粉丝数正式突破800万，成为日本女演员中社媒影响力最强的艺人之一。",
    contentHtml: `<p>近日，田中瞳的官方Instagram账号迎来了第800万位粉丝，这一里程碑式的数字再次印证了她在社交媒体上的巨大影响力。</p><p>田中瞳的社交媒体账号以真实、自然的内容风格著称。不同于许多明星精心策划的"完美形象"，她经常分享日常生活中的点滴——练琴时的认真、片场休息时的搞怪自拍、与工作人员一起吃外卖的温馨画面。</p><p>"社交媒体是连接我和粉丝们的桥梁，"田中瞳在一次采访中说，"我希望通过分享真实的生活片段，让粉丝们看到一个完整的、真实的我，而不仅仅是荧幕上的角色。"</p><p>为了庆祝800万粉丝达成，田中瞳特别发布了一段感谢视频，并宣布将随机抽取100位粉丝送出亲笔签名的《花语》写真集。该视频在发布24小时内获得了超过200万次播放。</p><p>在日本女演员的社交媒体影响力排行中，田中瞳目前位列第三，展现了她不仅在演技上，在粉丝运营方面同样出色的能力。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=A%20Japanese%20actress%20checking%20phone%20in%20a%20cozy%20setting%2C%20warm%20natural%20lighting%2C%20casual%20elegant%20style%2C%20professional%20lifestyle%20photography%2C%20cream%20and%20soft%20warm%20tones&width=800&height=450&seq=tanaka-article-12&orientation=landscape",
    publishDate: "2026-06-01",
    readTime: "3分钟",
    featured: false,
    tags: ["社交媒体", "粉丝", "Instagram"],
  },
];

export const aboutData = {
  brandName: "田中瞳官方资讯站",
  brandIntro: `田中瞳官方资讯与作品全览，是田中瞳粉丝自建的综合性资讯平台，致力于为广大粉丝提供最全面、最及时、最权威的田中瞳相关资讯。自2020年成立以来，我们始终秉持“真实、专业、深度”的原则，追踪报道田中瞳的每一项动态，整理收录她的每一部作品，打造粉丝与偶像之间的优质互动桥梁。`,
  mission: "连接田中瞳与全球粉丝，让每一位关注者都能第一时间了解她的最新动态，深入感受她的演艺魅力。",
  reputation: [
    "日本娱乐资讯类网站TOP50（2025年）",
    "月均访问量超过120万次",
    "累计收录田中瞳相关资讯超过2000篇",
    "与10余家日本娱乐媒体建立合作关系",
    "被粉丝评选为「最值得信赖的田中瞳资讯平台」",
  ],
  contact: {
    email: "contact@lampbus.cn",
    address: "东京都港区南青山2-15-8 青山大厦5F",
    weibo: "@田中瞳官方资讯站",
    twitter: "@tanaka_hitomi_news",
  },
};